export default {"src":"/_next/static/media/exclusive-podcast-dark.adfc5e2e.svg","height":100,"width":100};